export default class SitePiecesFacturationController {
	static $inject = [
		'$state',
		'$stateParams',
		'SitesService',
		'SitesTypesService',
		'ModalService',
		'notification',
		'$translate',
		'_',
		'$filter',
		'globalizationManagementService',
		'MassiaRightsService',
		'moment'
	];

	constructor(
		$state,
		$stateParams,
		SitesService,
		SitesTypesService,
		ModalService,
		notification,
		$translate,
		_,
		$filter,
		globalizationManagementService,
		MassiaRightsService,
		moment
	) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.SitesService = SitesService;
		this.SitesTypesService = SitesTypesService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this._ = _;
		this.$filter = $filter;
		this.pages = {
			current: 1,
			total: 0
		};
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.MassiaRightsService = MassiaRightsService;
		this.moment = moment;
	}

	async $onInit() {
		this.periodes = ['thisMonth', 'threeLastMonth', 'lastSixMonths', 'currentYear', 'allPeriods'];

		this.total = null;
		this.lastFactureDate = null;
		if (this.site.id) {
			await this.loadPageData(1);
		}
	}

	async loadPageData(pageNumber) {
		this.loading = true;
		const targetPage = pageNumber == -1 ? this.pages.current : pageNumber;
		try {
			const clientFacturesCount = await this.SitesService.getClientFacturesCount(this.site.id, targetPage);

			if (!clientFacturesCount?.items?.length) {
				this.clientFacturesCount = [];
				this.total = 0;
				return;
			}

			const now = this.moment();

			this.clientFacturesCount = clientFacturesCount.items.map((item) => {
				const momentDate = this.moment(item.siteSocieteLastFactureDate);

				return {
					...item,
					siteSocieteLastFactureDate: momentDate.format(this.dateFormat),
					siteSocieteLastFactureDateOld: now.diff(momentDate, 'years') >= 1,
					lastFactureDate: this.moment(item.lastFactureDate).format(this.dateFormat),
					facturesCount: {
						thisMonth: {
							factures: item.facturesCount.factureThisMonth,
							avoirs: item.facturesCount.avoirThisMonth
						},
						threeLastMonth: {
							factures: item.facturesCount.factureThreeLastMonth,
							avoirs: item.facturesCount.avoirThreeLastMonth
						},
						lastSixMonths: {
							factures: item.facturesCount.factureLastSixMonths,
							avoirs: item.facturesCount.avoirLastSixMonths
						},
						currentYear: {
							factures: item.facturesCount.factureCurrentYear,
							avoirs: item.facturesCount.avoirCurrentYear
						},
						allPeriods: {
							factures: item.facturesCount.factureAllPeriods,
							avoirs: item.facturesCount.avoirAllPeriods
						}
					}
				};
			});

			this.pages = {
				current: targetPage,
				total: Math.ceil(clientFacturesCount.total / clientFacturesCount.take)
			};

			this.total = this.clientFacturesCount[0]?.clientfacturesTotal;
			this.lastFactureDate = this.clientFacturesCount[0]?.lastFactureDate;
		} catch (error) {
			console.error('Error loading page data:', error);
		} finally {
			this.loading = false;
		}
	}

	async print(id, fileName, extension) {
		this.startLoading();
		try {
			const resultat = await this.SitesService.print(fileName);
			const data = resultat.data;
			let headers = resultat.headers;
			headers = headers();

			const contentType = headers['content-type'];
			const linkElement = document.createElement('a');

			const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
			const url = window.URL.createObjectURL(blob);
			linkElement.setAttribute('href', url);
			linkElement.setAttribute('download', fileName + '.' + extension);
			const clickEvent = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: false
			});
			linkElement.dispatchEvent(clickEvent);
		} catch (ex) {
			this.notification.error(this.$translate.instant('DOCUMENTS.PIECE_FACT_NOT_FOUND', { libelle: fileName }));
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {}
	stopLoading() {}

	openNewWindow(clientFactures, clickedPeriod) {
		var dates = this.bornesPeriode(clickedPeriod);
		const url = this.$state.href('factures.list');
		window.open(
			'gestion.html' +
				url +
				'?clientFacturationData=' +
				JSON.stringify({
					societeId: clientFactures.societeId,
					siteId: clientFactures.siteId,
					libelleSite: clientFactures.siteLibelle,
					dateDebut: dates.dateDebut,
					dateFin: dates.dateFin,
					codeClient: this.site.entete.code
				}),
			'_blank'
		);
	}

	bornesPeriode(key, today = new Date()) {
		const mToday = this.moment(today); // moment d’aujourd’hui
		let mDebut;

		const bornes = {
			thisMonth: () => mToday.clone().startOf('month'),
			threeLastMonth: () => mToday.clone().subtract(2, 'month').startOf('month'),
			lastSixMonths: () => mToday.clone().subtract(5, 'month').startOf('month'),
			currentYear: () => mToday.clone().startOf('year'),
			allPeriods: () => this.moment('2000-01-01')
		};

		mDebut = bornes[key]();

		return {
			dateDebut: mDebut.format(this.dateFormat),
			dateFin: mToday.format(this.dateFormat)
		};
	}
}
